import { AUDIENCE_CSV_ID_TYPE, AUDIENCE_TYPE } from '../constants/audiences.constant';
import {
  AudienceAdobe,
  AudienceAny,
  AudienceCsv,
  AudienceCsvDynamic,
  AudienceDynamic,
  AudienceEventDetail,
  AudienceExternal,
  AudienceFromFile,
  AudienceFtp,
  AudienceHttps,
  AudiencePerformanceReport,
  AudienceS3,
  AudienceSegment,
  AudienceStatic,
  AudienceSales,
} from '../models/audiences.model';

export const isAudienceCsv = (audience: AudienceAny): audience is AudienceCsv =>
  audience.type === AUDIENCE_TYPE.CSV && ('csvContent' in audience || 'csvFileURL' in audience);
export const isAudienceCsvDynamic = (audience: AudienceAny): audience is AudienceCsvDynamic =>
  audience.type === AUDIENCE_TYPE.CSV_DYNAMIC &&
  'csvIdType' in audience &&
  (audience as any).csvIdType === AUDIENCE_CSV_ID_TYPE.CUSTOMER_ID &&
  ('csvContent' in audience || 'csvFileURL' in audience);
export const isAudienceSegment = (audience: AudienceAny): audience is AudienceSegment =>
  audience.type === AUDIENCE_TYPE.SEGMENT && 'segment' in audience;
export const isAudienceAdobe = (audience: AudienceAny): audience is AudienceAdobe =>
  audience.type === AUDIENCE_TYPE.ADOBE && 'adobeId' in audience;
export const isAudienceFtp = (audience: AudienceAny): audience is AudienceFtp =>
  audience.type === AUDIENCE_TYPE.FTP &&
  'ftpIdType' in audience &&
  'ftpHost' in audience &&
  'ftpPort' in audience &&
  'ftpUsername' in audience &&
  'ftpPassword' in audience &&
  'ftpFileRoute' in audience;
export const isAudienceHttps = (audience: AudienceAny): audience is AudienceHttps =>
  audience.type === AUDIENCE_TYPE.HTTPS && 'httpsIdType' in audience && 'httpsFileUrl' in audience;
export const isAudienceExternal = (audience: AudienceAny): audience is AudienceExternal =>
  audience.type === AUDIENCE_TYPE.EXTERNAL;
export const isAudienceForSegment = (
  audience: AudienceAny
): audience is AudienceFromFile | AudienceExternal | AudiencePerformanceReport =>
  isAudienceFromFile(audience) ||
  isAudienceExternal(audience) ||
  isAudiencePerformanceReport(audience) ||
  isAudienceEventDetail(audience) ||
  isAudienceSales(audience);

export const isAudienceS3 = (audience: AudienceAny): audience is AudienceS3 =>
  audience.type === AUDIENCE_TYPE.S3 &&
  's3IdType' in audience &&
  's3FileRoute' in audience &&
  's3IntegrationId' in audience;
export const isAudiencePerformanceReport = (audience: AudienceAny): audience is AudiencePerformanceReport =>
  audience.type === AUDIENCE_TYPE.PERFORMANCE_REPORT &&
  'kpiType' in audience &&
  'filters' in audience &&
  'dateRange' in audience;
export const isAudienceEventDetail = (audience: AudienceAny): audience is AudienceEventDetail =>
  audience.type === AUDIENCE_TYPE.EVENT_DETAIL &&
  'idType' in audience &&
  'eventId' in audience &&
  'filters' in audience &&
  'dateRange' in audience;

export const isAudienceSales = (audience: AudienceAny): audience is AudienceSales =>
  audience.type === AUDIENCE_TYPE.SALES &&
  'idType' in audience &&
  'filters' in audience &&
  'dateRange' in audience;

export const isAudienceFromFile = (audience: AudienceAny): audience is AudienceFromFile =>
  isAudienceCsv(audience) ||
  isAudienceCsvDynamic(audience) ||
  isAudienceFtp(audience) ||
  isAudienceHttps(audience) ||
  isAudienceS3(audience);

export const isAudienceStatic = (audience: AudienceAny): audience is AudienceStatic =>
  isAudienceCsv(audience) ||
  isAudiencePerformanceReport(audience) ||
  isAudienceEventDetail(audience) ||
  isAudienceSales(audience);

export const isAudienceDynamic = (audience: AudienceAny): audience is AudienceDynamic =>
  isAudienceCsvDynamic(audience) ||
  isAudienceFtp(audience) ||
  isAudienceHttps(audience) ||
  isAudienceS3(audience) ||
  isAudienceExternal(audience) ||
  isAudienceSegment(audience);
